import { render, staticRenderFns } from "./PcFooter.vue?vue&type=template&id=537fa568&scoped=true"
import script from "./PcFooter.vue?vue&type=script&lang=js"
export * from "./PcFooter.vue?vue&type=script&lang=js"
import style0 from "./PcFooter.vue?vue&type=style&index=0&id=537fa568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fa568",
  null
  
)

export default component.exports